import { gql } from "@apollo/client";

export const GET_EVALUACIONES_PAGINATED_RECLAMOS = gql`
query GetAllEvaluaciones(
    $skip: Int
    $take: Int
    $where: t_EvaluacionFilterInput 
    $order: [t_EvaluacionSortInput!] 
) {
    contratosByPaciente(skip: $skip, take: $take, where: $where, order: $order)
    {
        items {
            idEvaluacion
            idPlanCuidadoNavigation{
                nombre
            }
            idTipoModuloNavigation {
                descripcion
            }
        }
        totalCount
    }
}`;

export const adaptEvaluacion = (evaluacion) => {
  return {
    id: evaluacion?.idEvaluacion,
    programa: evaluacion?.idTipoModuloNavigation?.descripcion,
    planCuidado: evaluacion?.idPlanCuidadoNavigation?.nombre
  };
};

export const adaptEvaluacionesArray = (
evaluaciones) =>
{
  return structuredClone(evaluaciones)?.
  map((evaluacion) => adaptEvaluacion(evaluacion));
};